import { Navigate, useRoutes } from "react-router-dom";
/** Layout */
import DashboardLayout from "../layouts/dashboard";
/** Organization */

import { auth } from "./routerHelper";
import { School } from "@mui/icons-material";



const route = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "leaderboard",
      // children: [
      //   { path: "overview", element: auth(<SchoolLeaderboardPage />) },
      //   // { path: "create", element: auth(<OrganizationCreatePage />) },
      //   // { path: "import", element: <></> },
      // ],
    },
  ],
};

export default route;
